export default {
    CREATE_ATTRIBUTE: "Создание атрибута"
};
